import { render, staticRenderFns } from "./ProductPerformanceDistributor.vue?vue&type=template&id=33dba00f&"
import script from "./ProductPerformanceDistributor.vue?vue&type=script&lang=js&"
export * from "./ProductPerformanceDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports